import {css} from '@emotion/core'

export const logo = css`
  padding: 30px 0 0 0;
`
